import { Logo, waLink, Reveal, fbLead } from "./primitives";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="pt-24 pb-12 px-6 md:px-10" style={{ background: "var(--olive)" }} data-testid="site-footer">
      <div className="mx-auto max-w-[1500px]">
        <Reveal>
          <div className="grid md:grid-cols-3 gap-12 md:gap-8 items-start">
            <div>
              <Logo size={64} />
              <p className="font-body text-xl mt-5 max-w-xs leading-relaxed" style={{ color: "rgba(245,238,223,0.72)" }}>
                By invite. For the circle. A private house of hospitality.
              </p>
            </div>

            <div>
              <p className="font-body text-2xl" style={{ color: "var(--ivory)" }}>Samaksh Bhasin</p>
              <p className="font-label text-sm font-light mt-1" style={{ color: "rgba(245,238,223,0.6)" }}>Founder, Hitakari House</p>
              <p className="font-label text-sm font-light mt-1" style={{ color: "rgba(245,238,223,0.6)" }}>Across India</p>
            </div>

            <div className="md:text-right">
              <span className="eyebrow" style={{ color: "var(--brass)" }}>Speak With Us</span>
              <div className="mt-4">
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => fbLead("whatsapp")}
                  className="inline-block font-label text-[0.78rem] tracking-[0.22em] uppercase px-8 py-4 font-light"
                  style={{ backgroundColor: "var(--ivory)", color: "var(--forest)", transition: "background-color 200ms ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "var(--sage)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "var(--ivory)"; }}
                  data-testid="footer-whatsapp-btn"
                >
                  Engage on WhatsApp
                </a>
                <a
                  href="https://instagram.com/hitakarihouse"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 flex items-center gap-2 justify-start md:justify-end font-label text-[0.78rem] tracking-[0.14em] font-light"
                  style={{ color: "rgba(245,238,223,0.75)" }}
                  data-testid="footer-instagram-link"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                  <span className="link-underline">@hitakarihouse</span>
                </a>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-20 pt-8 flex flex-col md:flex-row justify-between gap-4" style={{ borderTop: "1px solid rgba(120,132,107,0.35)" }}>
          <p className="font-label text-xs font-light" style={{ color: "rgba(245,238,223,0.5)" }}>
            &copy; {year} Hitakari House. Private and by invite.
          </p>
          <p className="font-label text-xs font-light tracking-[0.18em] uppercase" style={{ color: "rgba(245,238,223,0.45)" }}>
            Pan India &middot; By Invite
          </p>
        </div>
      </div>
    </footer>
  );
}
